export default __webpack_public_path__ + "assets/images/banner-lamelo.4866dc7f.png";